/**
 * Generates a unique target id in this format: `<package-name>#<task-name>` or `//#<task-name>`
 *
 * @param pkgName
 * @param task
 * @returns
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get getPackageAndTask () {
        return getPackageAndTask;
    },
    get getStagedTargetId () {
        return getStagedTargetId;
    },
    get getStartTargetId () {
        return getStartTargetId;
    },
    get getTargetId () {
        return getTargetId;
    }
});
function getTargetId(pkgName, task) {
    return `${typeof pkgName === "string" ? pkgName : ""}#${task}`;
}
function getPackageAndTask(targetId) {
    if (targetId.startsWith("Δ")) {
        return {
            packageName: undefined,
            task: targetId.slice(1)
        };
    } else if (targetId.includes("#")) {
        const parts = targetId.split("#");
        // `//#<task-name>` or `#<task-name>` means root by convention
        if (targetId.startsWith("#") || parts[0] === "//") {
            return {
                packageName: undefined,
                task: parts[1]
            };
        }
        return {
            packageName: parts[0],
            task: parts[1]
        };
    } else {
        return {
            packageName: undefined,
            task: targetId
        };
    }
}
const START_TARGET_ID = "__start";
function getStartTargetId() {
    return START_TARGET_ID;
}
function getStagedTargetId(task) {
    return `Δ${task}`;
}
